import { jsx as e } from "react/jsx-runtime";
function t(i) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg", ...i, children: /* @__PURE__ */ e(
    "path",
    {
      clipRule: "evenodd",
      d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM11.5712 4.77517C11.8619 4.48187 12.3324 4.47061 12.6369 4.74966C12.9604 5.04622 12.9705 5.55296 12.659 5.86215L7.42447 11.0585C7.03766 11.4424 6.41459 11.446 6.02348 11.0664L4.03454 9.13591C3.73689 8.84701 3.72307 8.37374 4.00336 8.06796C4.29824 7.74628 4.8018 7.73534 5.11037 8.04391L6.72785 9.66139L11.5712 4.77517Z",
      fill: "#2968FF",
      fillRule: "evenodd"
    }
  ) });
}
export {
  t as default
};
